import { paths } from '@constants/paths';

/**
 * The routes the shared energy flow navigates to, which differ per journey.
 */
interface EnergyJourneyPaths {
  tariff: string;
  details: string;
  noEnergyFallback: string;
}

// Default to Signup journey
const signupEnergyPaths: EnergyJourneyPaths = {
  tariff: paths.energy,
  details: paths.energyDetails,
  noEnergyFallback: paths.bundle,
};

export type { EnergyJourneyPaths };
export { signupEnergyPaths };
